<script lang="ts">
    import { Col } from "sveltestrap";
    import { CardFooter, ColorCardContent, SecondaryColorCard } from "../../../utils/Constant/Constant";
    import Card from "../../Core/Card.svelte";
</script>
<Col sm="12" xl="6">
    <Card cardHeaderprops="d-flex justify-content-between align-items-center pb-0 bg-secondary" headerTitle={SecondaryColorCard} cardBodyprops="bg-secondary" cardFooterprops="bg-secondary">
        <div slot="contentbody" >
            <p class="mb-0">{ColorCardContent}</p>
        </div>
        <div slot="contentfooter">
            <h6 class="mb-0 text-white">{CardFooter}</h6>
        </div>
    </Card>
</Col>